import { forwardRef } from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@mweb/zappos-ui/Tooltip';

import type { ProductBadgeProps } from 'components/common/ProductBadge/ProductBadge.types';
import { backgroundShadowClasses, containerClasses, contentClasses, tooltipClasses } from 'components/common/ProductBadge/ProductBadge.classes';
import { cn } from 'helpers/classnames';

export const ProductBadge = forwardRef<HTMLDivElement, ProductBadgeProps>((props: ProductBadgeProps, ref) => {
  const { children, helpText, background, fontColor = 'text-primary', className: wrapperClassName, badgeClassName, ...forwardProps } = props;

  // Background and color can be any background/fontColor prop compatible color (hex, rgb, color name, gradiant etc)
  const customStyles = {
    background: `${background}`,
    color: `${fontColor}`,
    className: badgeClassName
  };

  const contentContainerProps = {
    className: contentClasses,
    style: { color: customStyles.color }
  };

  return (
    <div ref={ref} className={cn(containerClasses, wrapperClassName)} {...forwardProps}>
      <div className={cn(backgroundShadowClasses, customStyles.className)} style={{ background: customStyles.background }} />
      {!helpText ? (
        <div className="relative">
          <div {...contentContainerProps}>{children}</div>
        </div>
      ) : (
        <div className="relative z-10">
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger>
                <div {...contentContainerProps}>{children}</div>
              </TooltipTrigger>
              <TooltipPortal>
                <TooltipContent side="bottom" sideOffset={4} align="start" alignOffset={16} className={tooltipClasses}>
                  {helpText}
                </TooltipContent>
              </TooltipPortal>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}
    </div>
  );
});
